import React from 'react';
import {
    BaseOperateView,
    BaseStagePlugin,
    useActiveStageIndex,
    useFramework,
    useLayerTransform,
    useLoadingMap,
    useScale,
} from '@/framework';
import { IExportPlugin, ITableLayer, LayerType, PluginType } from '@/version-types';
import LayerLoading from './layer-loading';
import TableLayerLoadingItemNode from './table-layer-loading-item-node';

const LoadingItem: React.FC<{ layerId: string; extraInfos?: string[] }> = React.memo(({ layerId, extraInfos }) => {
    const framework = useFramework();
    const refNode = useLayerTransform(layerId);
    const scale = useScale();

    const layer = framework.getLayer(layerId);

    if (!layer) return null;

    let loadingNode: React.ReactNode = <LayerLoading />;

    if (layer.layerType === LayerType.TABLE) {
        loadingNode = (
            <div style={{ transform: `scale(${scale})`, transformOrigin: 'top left' }}>
                <TableLayerLoadingItemNode layer={layer as ITableLayer} />
            </div>
        );
    }

    return (
        <BaseStagePlugin originIndexOrLayerId={layerId} name="layer-loading">
            <BaseOperateView ref={refNode} layer={layer}>
                {loadingNode}
            </BaseOperateView>
        </BaseStagePlugin>
    );
});

/** 图层加载状态 */
const LayerLoadingPlugin: React.FC = React.memo(() => {
    const loadingMap = useLoadingMap();
    const layerIds = Object.keys(loadingMap);
    const activeStageIndex = useActiveStageIndex();
    const framework = useFramework();
    if (layerIds.length === 0) return null;

    const list = layerIds.filter((layerId) => {
        const isLongImageMode = framework.stage.isLongImageMode();
        if (isLongImageMode) {
            return true;
        }
        const originIndex = framework.tryGetLayerOriginIndex(layerId);
        return originIndex === framework.convertStageToOrigin(activeStageIndex);
    });

    return (
        <>
            {list.map((layerId) => {
                return <LoadingItem key={layerId} extraInfos={loadingMap[layerId]} layerId={layerId} />;
            })}
        </>
    );
});

const exportPlugin: IExportPlugin = {
    type: PluginType.STAGE,
    sort: 20,
    name: 'layer-loading',
    render() {
        return <LayerLoadingPlugin />;
    },
};

export default exportPlugin;
